<script>
/**
 * Page-header component
 */
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    showModal: Function
  },
  methods: {
    manageInfoModal() {
      this.$emit('showModal')
    }
  }
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0 font-size-18">
          {{ title }}
          <template v-if="showInfo">
            <a href="javascript:void(0);" @click="manageInfoModal">
              <i class="fas fa-info-circle text-info"></i>
            </a>
          </template>
        </h4>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
